













































































































































































































































































































































































































































































import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import {
  IInventoryAdvancePayment,
  User,
  IUser,
  InventoryAdvancePaymentStatusEnum
} from '@/models';

import { colors, classToHex } from '@/utils/colorUtils';
import { ErrorManager } from '@/models/error';
import { ISystemError } from '@/models/error/error.types';
import { ExtractVue } from '@/utils/mixins';

import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';

import InventoryAdvancePaymentDetailFormDialog from '@/components/inventory-advance-payment/InventoryAdvancePaymentDetailFormDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import InventoryAdvancePaymentAPSpecialistPicker from './InventoryAdvancePaymentAPSpecialistPicker.vue';
import InventoryAdvancePaymentApprovedStateCardActions from './state/InventoryAdvancePaymentApprovedStateCardActions.vue';
import InventoryAdvancePaymentApSpecialistAssignedStateCardActions from './state/InventoryAdvancePaymentApSpecialistAssignedStateCardActions.vue';

import InventoryAdvancePaymentFinanceManagerAssignedStateCardActions from './state/InventoryAdvancePaymentFinanceManagerAssignedStateCardActions.vue';
import InventoryAdvancePaymentRequestProcessedStateCardActions from './state/InventoryAdvancePaymentRequestProcessedStateCardActions.vue';
import InventoryAdvancePaymentPaidStateCardActions from './state/InventoryAdvancePaymentPaidStateCardActions.vue';
import InventoryAdvancePaymentInvoiceInProgressStateCardActions from './state/InventoryAdvancePaymentInvoiceInProgressStateCardActions.vue';
import InventoryAdvancePaymentInvoiceProcessedStateCardActions from './state/InventoryAdvancePaymentInvoiceProcessedStateCardActions.vue';
import InventoryAdvancePaymentClearingInProgressStateCardActions from './state/InventoryAdvancePaymentClearingInProgressStateCardActions.vue';
import InventoryAdvancePaymentClearedStateCardActions from './state/InventoryAdvancePaymentClearedStateCardActions.vue';
import InventoryAdvancePaymentStateTransitionCommentFormDialog from './common/InventoryAdvancePaymentStateTransitionCommentFormDialog.vue';

const baseMixins = mixins(authMixin);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    commentDialog: InstanceType<
      typeof InventoryAdvancePaymentStateTransitionCommentFormDialog
    >;
  };
}
export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'InventoryAdvancePaymentStateCard',

    components: {
      InventoryAdvancePaymentDetailFormDialog,
      ConfirmationDialog,
      ErrorAlert,
      InventoryAdvancePaymentAPSpecialistPicker,
      InventoryAdvancePaymentApprovedStateCardActions,
      InventoryAdvancePaymentFinanceManagerAssignedStateCardActions,
      InventoryAdvancePaymentRequestProcessedStateCardActions,
      InventoryAdvancePaymentApSpecialistAssignedStateCardActions,
      InventoryAdvancePaymentPaidStateCardActions,
      InventoryAdvancePaymentInvoiceInProgressStateCardActions,
      InventoryAdvancePaymentInvoiceProcessedStateCardActions,
      InventoryAdvancePaymentClearingInProgressStateCardActions,
      InventoryAdvancePaymentClearedStateCardActions,
      InventoryAdvancePaymentStateTransitionCommentFormDialog
    },

    props: {
      inventoryAdvancePayment: {
        type: Object as PropType<IInventoryAdvancePayment>,
        required: true
      }
    },

    data: () => ({
      loading: false,
      errorMessage: '',
      errorMessageDetail: '',
      InventoryAdvancePaymentStatusEnum,

      submitInventoryPaymentApprover: null as null | IUser,
      submitInventoryPaymentDialog: false,

      cancelPaymentDialog: false,

      // comment sections
      actionToState: -1,
      commentsPaymentDialog: false,
      resolve: (null as unknown) as (
        value: boolean | PromiseLike<boolean>
      ) => void,
      inventoryAdvancePaymentComment: '',
      actionLabel: ''
    }),

    computed: {
      ...mapGetters({
        approvers: 'inventoryAdvancePayment/getInventoryAdvancePaymentApprovers'
      }),

      authProvider(): any {
        return this.$altoleapAccounts.authProvider;
      },

      currentUser(): User {
        return this.authProvider.getCurrentUser;
      },

      commentMandatory(): boolean {
        return (
          (this.actionToState == InventoryAdvancePaymentStatusEnum.Cancelled ||
            this.actionToState == InventoryAdvancePaymentStatusEnum.Rejected) &&
          !(
            this.inventoryAdvancePayment.status!.value ==
              InventoryAdvancePaymentStatusEnum.Submitted ||
            this.inventoryAdvancePayment.status!.value! ==
              InventoryAdvancePaymentStatusEnum.Draft
          )
        );
      },

      mandatoryCommentFieldIsEmpty(): boolean {
        return (
          this.commentMandatory &&
          this.inventoryAdvancePaymentComment.length == 0
        );
      },

      canApprove(): boolean {
        if (
          this.inventoryAdvancePayment.approvers &&
          this.inventoryAdvancePayment.approvers.length
        ) {
          const approver = this.inventoryAdvancePayment.approvers.find(
            inventoryAdvancePaymentApprover => {
              return (
                this.currentUser.id ===
                (inventoryAdvancePaymentApprover.approver as IUser).id
              );
            }
          );
          //return true if approve is identified
          if (approver) {
            return true;
          }
        }
        return false;
      },

      isInventoryAdvancePaymentOwner(): boolean {
        return (
          this.currentUser.id ===
          (this.inventoryAdvancePayment.owner as IUser).id
        );
      },

      getStatusIcon(): string {
        return this.inventoryAdvancePayment.status!.getIcon();
      },

      getStatusMessage(): string {
        switch (this.inventoryAdvancePayment.status!.value) {
          case InventoryAdvancePaymentStatusEnum.Draft:
            return 'Draft';

          case InventoryAdvancePaymentStatusEnum.Submitted:
            return 'Submitted for approval';

          case InventoryAdvancePaymentStatusEnum.InReview:
            return 'Review In Progress';

          case InventoryAdvancePaymentStatusEnum.Approval2Pending:
            return 'Approval II Pending';

          case InventoryAdvancePaymentStatusEnum.Approved:
            return 'Approved';

          case InventoryAdvancePaymentStatusEnum.Rejected:
            return 'Rejected';

          case InventoryAdvancePaymentStatusEnum.Cancelled:
            return 'Cancelled';

          case InventoryAdvancePaymentStatusEnum.Paid:
            return 'Paid';

          case InventoryAdvancePaymentStatusEnum.APSpecialistAssigned:
            return 'A/P Specialist Assigned';

          case InventoryAdvancePaymentStatusEnum.FinanceManagerAssigned:
          case InventoryAdvancePaymentStatusEnum.RequestProcessed:
          case InventoryAdvancePaymentStatusEnum.InvoiceInProgress:
          case InventoryAdvancePaymentStatusEnum.InvoiceProcessed:
          case InventoryAdvancePaymentStatusEnum.ClearingInProgress:
          case InventoryAdvancePaymentStatusEnum.Cleared:
          default:
            return this.inventoryAdvancePayment.status!.display_name;
        }
      },

      getStatusColor(): string {
        return this.inventoryAdvancePayment.status!.getColor();
      },

      getStatusHexColor(): string {
        return classToHex(
          this.inventoryAdvancePayment.status!.getColor(),
          colors,
          this.$vuetify.theme.currentTheme
        );
      }
    },

    mounted() {
      this.loadNextInventoryAdvancePaymentApprovers();
    },

    methods: {
      ...mapActions({
        updateInventoryAdvancePaymentState:
          'inventoryAdvancePayment/updateInventoryAdvancePaymentState',
        fetchInventoryAdvancePaymentApprovers:
          'inventoryAdvancePayment/fetchInventoryAdvancePaymentApprovers',
        fetchInventoryAdvancePaymentActivities:
          'inventoryAdvancePayment/fetchInventoryAdvancePaymentActivities'
      }),

      setActionLabel(state: InventoryAdvancePaymentStatusEnum) {
        switch (state) {
          case InventoryAdvancePaymentStatusEnum.Draft:
            this.actionLabel = '';
            break;

          case InventoryAdvancePaymentStatusEnum.Submitted:
            this.actionLabel = 'Submit';
            break;

          case InventoryAdvancePaymentStatusEnum.InReview:
          case InventoryAdvancePaymentStatusEnum.Approval2Pending:
            this.actionLabel = 'Start Review';
            break;

          case InventoryAdvancePaymentStatusEnum.Approved:
            this.actionLabel = 'Approve';
            break;

          case InventoryAdvancePaymentStatusEnum.Rejected:
            this.actionLabel = 'Reject';
            break;

          case InventoryAdvancePaymentStatusEnum.Cancelled:
            this.actionLabel = 'Cancel';
            break;

          case InventoryAdvancePaymentStatusEnum.Paid:
            this.actionLabel = 'Close';
            break;

          default:
            this.actionLabel = 'Submit';
            break;
        }
      },

      updateInventoryAdvancePayment(): void {
        const inventoryAdvancePaymentFormDialog = this.$refs
          .inventoryAdvancePaymentDetailFormDialog as ExtractVue<
          typeof InventoryAdvancePaymentDetailFormDialog
        >;
        inventoryAdvancePaymentFormDialog.open(
          this.inventoryAdvancePayment,
          true
        );
      },

      agreeCommentsDialog() {
        this.commentsPaymentDialog = false;
        return this.resolve(true);
      },

      cancelCommentsDialog() {
        this.commentsPaymentDialog = false;
        return this.resolve(false);
      },

      /**
       * @summary Await this dialog to close before continuing into the next action.
       */
      openCommentsDialog(toState: InventoryAdvancePaymentStatusEnum) {
        this.actionToState = toState;
        this.setActionLabel(toState);

        this.inventoryAdvancePaymentComment = '';
        this.commentsPaymentDialog = true;

        return new Promise((resolve, reject) => {
          this.resolve = resolve;
        });
      },

      /**
       * @see api inventoryAdvancePayment/models/start_review
       * can be called only from states:
       * - Draft
       *
       * can go to states
       * - Submitted
       *
       * if approver not assigned then call @see undoSubmit
       */
      async submit(assignee: number): Promise<void> {
        const {
          isConfirmed,
          comment
        } = await this.$refs.commentDialog.openCommentsDialog(
          InventoryAdvancePaymentStatusEnum.Submitted
        );
        if (isConfirmed) {
          this.clearAllErrors();

          this.loading = true;

          this.updateInventoryAdvancePaymentState({
            id: this.inventoryAdvancePayment.id,
            state: InventoryAdvancePaymentStatusEnum.Submitted,
            assignee: assignee,
            comment: comment
          })
            .then(() => {
              this.submitInventoryPaymentDialog = false;
              this.submitInventoryPaymentApprover = null;
              this.$emit('submitted');
              this.fetchInventoryAdvancePaymentActivities(
                this.inventoryAdvancePayment.id
              );
            })
            .catch(error => {
              if (error.response && error.response.data.detail) {
                this.errorMessageDetail = error.response.data.detail;
              }
              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },

      /**
       * @see api inventoryAdvancePayment/models/start_review
       * can be called only from states:
       * - Submitted
       *
       * can go to states
       * - Draft
       */
      undoSubmit() {
        this.clearAllErrors();
        this.loading = true;
        this.updateInventoryAdvancePaymentState({
          id: this.inventoryAdvancePayment.id,
          state: InventoryAdvancePaymentStatusEnum.Draft
        })
          .then(() => {
            this.$emit('undo-submit');
            this.loadNextInventoryAdvancePaymentApprovers();
            this.fetchInventoryAdvancePaymentActivities(
              this.inventoryAdvancePayment.id
            );
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      /**
       * @see api inventoryAdvancePayment/models/start_review
       * can be called only from states:
       * - Submitted
       *
       * can go to states
       * - InReview
       */
      async startReview(): Promise<void> {
        const {
          isConfirmed,
          comment
        } = await this.$refs.commentDialog.openCommentsDialog(
          InventoryAdvancePaymentStatusEnum.InReview
        );
        if (isConfirmed) {
          this.clearAllErrors();
          this.loading = true;
          this.updateInventoryAdvancePaymentState({
            id: this.inventoryAdvancePayment.id,
            state: InventoryAdvancePaymentStatusEnum.InReview,
            comment: comment
          })
            .then(() => {
              this.$emit('start-review');
              this.loadNextInventoryAdvancePaymentApprovers();
              this.fetchInventoryAdvancePaymentActivities(
                this.inventoryAdvancePayment.id
              );
            })
            .catch(error => {
              if (error.response && error.response.data.detail) {
                this.errorMessageDetail = error.response.data.detail;
              }
              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },

      /**
       * @see api inventoryAdvancePayment/models/reject
       * @param {number} assignee
       * can be called only from states:
       * - Any State
       *
       * can go to states
       * - Rejected
       */
      async reject(assignee: number): Promise<void> {
        const {
          isConfirmed,
          comment
        } = await this.$refs.commentDialog.openCommentsDialog(
          InventoryAdvancePaymentStatusEnum.Rejected
        );
        if (isConfirmed) {
          this.clearAllErrors();
          this.loading = true;
          this.updateInventoryAdvancePaymentState({
            id: this.inventoryAdvancePayment.id,
            state: InventoryAdvancePaymentStatusEnum.Rejected,
            assignee: assignee, //only current user can reject a payment,
            comment: comment
          })

            .then(() => {
              this.$emit('reject');
              this.fetchInventoryAdvancePaymentActivities(
                this.inventoryAdvancePayment.id
              );
            })
            .catch(error => {
              if (error.response && error.response.data.detail) {
                this.errorMessageDetail = error.response.data.detail;
              }
              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },

      /**
       * @see api inventoryAdvancePayment/models/approve
       * @param {number} assignee
       * can be called only from states:
       * - InReview
       *
       * can go to states
       * - Approved
       */
      async approve(assignee: number): Promise<void> {
        const {
          isConfirmed,
          comment
        } = await this.$refs.commentDialog.openCommentsDialog(
          InventoryAdvancePaymentStatusEnum.Approved
        );
        if (isConfirmed) {
          this.clearAllErrors();
          this.loading = true;

          this.updateInventoryAdvancePaymentState({
            id: this.inventoryAdvancePayment.id,
            state: InventoryAdvancePaymentStatusEnum.Approved,
            assignee: assignee,
            comment: comment
          })
            .then(() => {
              this.fetchInventoryAdvancePaymentActivities(
                this.inventoryAdvancePayment.id
              );
            })
            .catch(error => {
              if (error.response && error.response.data.detail) {
                this.errorMessageDetail = error.response.data.detail;
              }
              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },

      /**
       * @see api inventoryAdvancePayment/models/cancel
       * can be called only from states:
       * - Any state
       *
       * can go to states
       * - Cancel
       */
      async cancel(): Promise<void> {
        const {
          isConfirmed,
          comment
        } = await this.$refs.commentDialog.openCommentsDialog(
          InventoryAdvancePaymentStatusEnum.Cancelled
        );
        if (isConfirmed) {
          this.clearAllErrors();
          this.loading = true;
          this.updateInventoryAdvancePaymentState({
            id: this.inventoryAdvancePayment.id,
            state: InventoryAdvancePaymentStatusEnum.Cancelled,
            comment: comment
          })
            .then(() => {
              this.$emit('cancel');
              this.fetchInventoryAdvancePaymentActivities(
                this.inventoryAdvancePayment.id
              );
            })
            .catch(error => {
              if (error.response && error.response.data.detail) {
                this.errorMessageDetail = error.response.data.detail;
              }
              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },

      onErrorHandler(error: ISystemError) {
        this.clearAllErrors();
        this.errorMessage = error.message;
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.errorMessageDetail = '';
      },

      loadNextInventoryAdvancePaymentApprovers() {
        this.loading = true;
        return this.fetchInventoryAdvancePaymentApprovers(
          this.inventoryAdvancePayment.id
        )
          .catch(() => {
            this.errorMessage = 'Error getting approvers';
          })
          .finally(() => (this.loading = false));
      }
    }
  });
